var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "#D9D9D9",
    fillOpacity: 0.1,
    stroke: "#B88333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5093 16.086C41.3246 16.6998 41.5071 17.8803 40.9141 18.7244L26.3172 39.5008C26.0036 39.9494 25.5189 40.2268 24.9829 40.2741C24.447 40.3213 23.9281 40.1147 23.5518 39.7251L16.2533 32.17C15.5406 31.4322 15.5406 30.2341 16.2533 29.4963C16.966 28.7585 18.1235 28.7585 18.8363 29.4963L24.6237 35.4872L37.9662 16.4991C38.5592 15.6551 39.6996 15.4662 40.515 16.0801L40.5093 16.086Z",
    fill: "#B88333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.53d440c270ecc979a0c16bf9240dd984.svg";
export { ForwardRef as ReactComponent };